// Written by scripts/stamp.js on every build. The value committed is
// a placeholder, so a fresh clone compiles before anything is run.
export const BUILD_STAMP = "aee7aab3e3b68c1e85afa6ce9af70d7733afb9cb";
